import { render, staticRenderFns } from "./PrintOrderV1.vue?vue&type=template&id=479c1f38&scoped=true"
import script from "./PrintOrderV1.vue?vue&type=script&lang=js"
export * from "./PrintOrderV1.vue?vue&type=script&lang=js"
import style0 from "./PrintOrderV1.vue?vue&type=style&index=0&id=479c1f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479c1f38",
  null
  
)

export default component.exports